import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Sort-down icon — descending sort glyph.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const SortDownIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M10.667 13.834C10.9431 13.834 11.167 13.6101 11.167 13.334C11.167 13.0578 10.9431 12.834 10.667 12.834H4.66699C4.39085 12.834 4.16699 13.0578 4.16699 13.334C4.16699 13.6101 4.39085 13.834 4.66699 13.834H10.667Z"
      fill="currentColor"
    />
    <path
      d="M10.667 10.834C10.943 10.8338 11.167 10.61 11.167 10.334C11.167 10.058 10.943 9.83416 10.667 9.83398H6C5.72386 9.83398 5.5 10.0578 5.5 10.334C5.5 10.6101 5.72386 10.834 6 10.834H10.667Z"
      fill="currentColor"
    />
    <path
      d="M10.667 7.83398C10.9431 7.83398 11.167 7.61013 11.167 7.33398C11.167 7.05784 10.9431 6.83398 10.667 6.83398H7.33398C7.05784 6.83398 6.83398 7.05784 6.83398 7.33398C6.83398 7.61013 7.05784 7.83398 7.33398 7.83398H10.667Z"
      fill="currentColor"
    />
    <path
      d="M12.833 4.66481V15.3318C12.833 15.547 12.9706 15.7384 13.1748 15.8064C13.379 15.8745 13.6043 15.8038 13.7334 15.6316L15.7334 12.9656C15.8991 12.7447 15.8537 12.4311 15.6328 12.2654C15.4119 12.0997 15.0983 12.1441 14.9326 12.365L13.833 13.8318V4.66481C13.8328 4.38882 13.609 4.16481 13.333 4.16481C13.057 4.16481 12.8332 4.38882 12.833 4.66481Z"
      fill="currentColor"
    />
  </svg>
);

export default SortDownIcon;
